module.exports = __webpack_public_path__ + "static/media/b2.6c6d047c.webp";